import { Box, Center, Img, Progress, Spacer, Stack, Text } from '@chakra-ui/react'
import { faCheck } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { FONT_FAMILY } from '@/constants/constants'

import ShwLink from '@/components/ShwLink'

export default function BadgeDetail({
  iconUrl,
  title,
  subtitle,
  link,
  criteria,
}: {
  iconUrl: string
  title: string
  subtitle: string

  link?: string | null
  criteria?: { targetValue: number; currentValue: number }
}): JSX.Element {
  const completed = criteria == null || criteria.currentValue >= criteria.targetValue

  return (
    <Stack
      direction="column"
      spacing="0px"
      align="center"
      textDecoration="none"
      borderRadius="8px"
      border="2px solid"
      borderColor="border"
      px="8px"
      py="8px"
      height="100%"
      bg="bg"
      width="152px"
      textAlign="center"
    >
      <Center height="70px" mb="8px">
        <Img src={iconUrl} height="60px" />
      </Center>
      <Text size="md" fontWeight="bold" fontSize="16px">
        {title}
      </Text>
      <Spacer />
      <Box height="60px" width="100%" pt="10px">
        {completed ? (
          link == null ? (
            <Text fontSize="14px" fontWeight={500} lineHeight="16px" color="fg.success">
              <FontAwesomeIcon icon={faCheck} /> {subtitle}
            </Text>
          ) : (
            <ShwLink fontSize="14px" fontWeight={500} href={link} color="fg.success">
              <FontAwesomeIcon icon={faCheck} /> {subtitle}
            </ShwLink>
          )
        ) : (
          <Box width="100%">
            <Text fontSize="14px" fontWeight={500} lineHeight="16px" color="fg.muted">
              {subtitle}
            </Text>
            <Stack direction="row" spacing={3} align="center" mt={1} width="100%">
              <Progress
                flex={1}
                value={(criteria.currentValue * 100) / criteria.targetValue}
                height="10px"
                borderRadius="5px"
                colorScheme="yellow"
              />
              <Text
                color="fg.subtle"
                fontSize="14px"
                fontFamily={FONT_FAMILY.heading}
                fontWeight={500}
              >
                {criteria.currentValue} / {criteria.targetValue}
              </Text>
            </Stack>
          </Box>
        )}
      </Box>
    </Stack>
  )
}
